import { render, staticRenderFns } from "./iCardTop.vue?vue&type=template&id=4a7065bc&scoped=true"
import script from "./iCardTop.vue?vue&type=script&lang=js"
export * from "./iCardTop.vue?vue&type=script&lang=js"
import style0 from "./iCardTop.vue?vue&type=style&index=0&id=4a7065bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7065bc",
  null
  
)

export default component.exports